export const generateTemplates = (keyword = 'Jobs', defaultABT = '(555) 123-4567', formValues = {}) => {
  const {
    logoUrl = null,
    brandName = "We're Hiring!",
    subHeading = "",
    careerSiteUrl = "",
    disclaimer = "Message and data rates may apply."
  } = formValues;

  const trimmedCareerSiteUrl = (careerSiteUrl || '').trim();
  const trimmedDisclaimer = (disclaimer || '').trim();
  const trimmedSubHeading = (subHeading || '').trim();
  const showCareerSite = Boolean(trimmedCareerSiteUrl);
  const showDisclaimer = Boolean(trimmedDisclaimer);
  const showSubHeading = Boolean(trimmedSubHeading);

  // Helper to build headline content array with optional subheading
  const buildHeadlineContent = (headlineText, headlineColor, subColor, headlineFontSize) => {
    const headlineMarkAttrs = { color: headlineColor };
    if (headlineFontSize) headlineMarkAttrs.fontSize = headlineFontSize;
    const nodes = [
      {
        type: "heading",
        attrs: { level: 1, textAlign: "center" },
        content: [{
          type: "text",
          text: headlineText,
          marks: [{ type: "textStyle", attrs: headlineMarkAttrs }]
        }]
      }
    ];
    if (showSubHeading) {
      nodes.push({
        type: "paragraph",
        attrs: { textAlign: "center" },
        content: [{
          type: "text",
          text: trimmedSubHeading,
          marks: [{ type: "textStyle", attrs: { color: subColor || '#333333', fontSize: "18px"   } }]
        }]
      });
    }
    return nodes;
  };

  return [
    {
      id: "template-modern-bold-01",
      name: "Classic",
      globalSettings: {
        backgroundColor: "#FFFFFF",
        brandColor: "#38b549",
        fontPairing: { heading: "Inter, sans-serif", body: "Roboto, sans-serif" }
      },
      elements: [
        {
          id: "el-logo-1",
          type: "logo",
          layout: { x: 228, y: 30, w: 360, h: 90, z: 1 },
          props: { url: logoUrl, fitMode: "contain", alignment: "center" }
        },
        {
          id: "el-text-headline",
          type: "text",
          layout: { x: 50, y: 126, w: 716, h: showSubHeading ? 100 : 88, z: 2 },
          content: {
            type: "doc",
            content: buildHeadlineContent(brandName || "We're Hiring!", "#38b549", "#333333")
          }
        },
        {
          id: "el-qr-1",
          type: "qr",
          layout: { x: 248, y: showSubHeading ? 240 : 220, w: 320, h: 320, z: 3 },
          props: { showLabel:false, labelText: "SCAN TO APPLY", cornerStyle: "rounded" }
        },
        {
          id: "el-text-camera-instructions",
          type: "text",
          layout: { x: 70, y: 570, w: 676, h: 72, z: 4 },
          content: {
            type: "doc",
            content: [
              {
                type: "heading",
                attrs: { level: 3, textAlign: "center" },
                content: [{
                  type: "text",
                  text: "Hold your phone camera up to the QR code, and your camera will open a text message to start the apply process."
                }]
              }
            ]
          }
        },
        {
          id: "el-text-or",
          type: "text",
          layout: { x: 50, y: 654, w: 716, h: 42, z: 5 },
          content: {
            type: "doc",
            content: [
              {
                type: "heading",
                attrs: { level: 3, textAlign: "center" },
                content: [{ type: "text", marks: [{ type: "bold" }], text: "or" }]
              }
            ]
          }
        },
        {
          id: "el-text-apply-by-text",
          type: "text",
          layout: { x: 50, y: 698, w: 716, h: 66, z: 6 },
          content: {
            type: "doc",
            content: [
              {
                type: "heading",
                attrs: { level: 1, textAlign: "center" },
                content: [{
                  type: "text",
                  text: "Apply by Text",
                  marks: [{ type: "textStyle", attrs: { color: "#38b549" } }]
                }]
              }
            ]
          }
        },
        {
          id: "el-text-instructions",
          type: "text",
          layout: { x: 50, y: 772, w: 716, h: 72, z: 7 },
          content: {
            type: "doc",
            content: [
              {
                type: "heading",
                attrs: { level: 2, textAlign: "center" },
                content: [
                  { type: "text", marks: [{ type: "bold" }], text: "Text " },
                  { type: "text", marks: [{ type: "bold" }, { type: "textStyle", attrs: { color: "#38b549" } }], text: `"${keyword}"` },
                  { type: "text", text: " to " },
                  {
                    type: "text",
                    marks: [{ type: "bold" }, { type: "textStyle", attrs: { color: "#38b549" } }],
                    text: defaultABT
                  }
                ]
              }
            ]
          }
        },
        ...(showCareerSite ? [{
          id: "el-text-career-site",
          type: "text",
          layout: { x: 50, y: 856, w: 716, h: 40, z: 8 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [
                  { type: "text", text: "You may also visit " },
                  { type: "text", text: trimmedCareerSiteUrl }
                ]
              }
            ]
          }
        }] : []),
        ...(showDisclaimer ? [{
          id: "el-text-disclaimer",
          type: "text",
          layout: { x: 50, y: showCareerSite ? 902 : 872, w: 716, h: 40, z: 9 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [{ type: "text", text: trimmedDisclaimer }]
              }
            ]
          }
        }] : []),
        {
          id: "el-text-fixed-rates",
          type: "text",
          layout: { x: 50, y: (showCareerSite ? 948 : 918) + (showDisclaimer ? 0 : -30), w: 716, h: 40, z: 10 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [{ type: "text", text: "Message and data rates may apply. Message frequency varies." }]
              }
            ]
          }
        },
        {
          id: "el-text-trademark",
          type: "text",
          layout: { x: 50, y: (showCareerSite ? 988 : 958) + (showDisclaimer ? 0 : -30), w: 716, h: 56, z: 11 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [
                  { type: "text", marks: [{ type: "bold" }], text: "Apply by Text and Scan to Apply are registered trademarks of" },
                  { type: "hardBreak" },
                  { type: "text", marks: [{ type: "bold" }], text: "GoHire, Inc. * GoHire.com" }
                ]
              }
            ]
          }
        }
      ]
    },
    {
      id: "template-corporate-modern-02",
      name: "Corporate Modern",
      globalSettings: {
        backgroundColor: "#FFFFFF",
        brandColor: "#38b549",
        fontPairing: { heading: "Montserrat, sans-serif", body: "Montserrat, sans-serif" }
      },
      elements: [
        {
          id: "el-logo-1",
          type: "logo",
          layout: { x: 228, y: 30, w: 360, h: 90, z: 1 },
          props: { url: logoUrl, fitMode: "contain", alignment: "center" }
        },
        {
          id: "el-text-headline",
          type: "text",
          layout: { x: 50, y: 130, w: 716, h: showSubHeading ? 100 : 80, z: 2 },
          content: {
            type: "doc",
            content: buildHeadlineContent("WE'RE HIRING!", "#38b549", "#1f2937")
          }
        },
        {
          id: "el-qr-1",
          type: "qr",
          layout: { x: 233, y: showSubHeading ? 250 : 260, w: 350, h: 420, z: 3 },
          props: {
            showLabel: true,
            labelText: "SCAN TO APPLY",
            labelColor: "#38b549",
            finderColor: "#38b549",
            bgColor: "#ffffff",
            color: "#000000",
            iconSizeRatio: 0.22,
            containerStyle: {
              border: '10px solid #38b549',
              borderRadius: '24px',
              padding: '24px',
              paddingBottom: '24px'
            }
          }
        },
        {
          id: "el-text-apply-by",
          type: "text",
          layout: { x: 50, y: 720, w: 716, h: 70, z: 4 },
          content: {
            type: "doc",
            content: [
              {
                type: "heading",
                attrs: { level: 1, textAlign: "center" },
                content: [{
                  type: "text",
                  text: "Apply by Text",
                  marks: [{ type: "textStyle", attrs: { color: "#38b549" } }]
                }]
              }
            ]
          }
        },
        {
          id: "el-text-instructions",
          type: "text",
          layout: { x: 50, y: 800, w: 716, h: 60, z: 5 },
          content: {
            type: "doc",
            content: [
              {
                type: "heading",
                attrs: { level: 2, textAlign: "center" },
                content: [
                  { type: "text", text: "Text " },
                  { type: "text", marks: [{ type: "bold" }], text: `'${String(keyword || 'JOBS').toUpperCase()}'` },
                  { type: "text", text: " to " },
                  { type: "text", text: defaultABT }
                ]
              }
            ]
          }
        },
        ...(showCareerSite ? [{
          id: "el-text-career-site",
          type: "text",
          layout: { x: 50, y: 880, w: 716, h: 40, z: 6 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [
                  { type: "text", text: "You may also visit " },
                  { type: "text", text: trimmedCareerSiteUrl }
                ]
              }
            ]
          }
        }] : []),
        ...(showDisclaimer ? [{
          id: "el-text-disclaimer",
          type: "text",
          layout: { x: 70, y: showCareerSite ? 920 : 880, w: 676, h: 40, z: 7 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [{ type: "text", text: trimmedDisclaimer }]
              }
            ]
          }
        }] : []),
        {
          id: "el-text-trademark",
          type: "text",
          layout: { x: 70, y: (showCareerSite ? 960 : 920) + (showDisclaimer ? 0 : -40), w: 676, h: 56, z: 8 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [
                  { type: "text", text: "Apply by Text and Scan to Apply are registered trademarks of" },
                  { type: "hardBreak" },
                  { type: "text", text: "GoHire, Inc. * GoHire.com" }
                ]
              }
            ]
          }
        }
      ]
    },
    {
      id: "template-industrial-high-impact-03",
      name: "Industrial High-Impact",
      globalSettings: {
        backgroundColor: "#0d0d0d",
        brandColor: "#f59b20",
        fontPairing: { heading: "Impact, sans-serif", body: "Arial, sans-serif" }
      },
      elements: [
        {
          id: "el-background-border",
          type: "text",
          layout: { x: 30, y: 130, w: 756, h: 686, z: 1 },
          props: {
            containerStyle: {
              border: '14px solid #f59b20',
              backgroundColor: "transparent"
            }
          },
          content: { type: "doc", content: [] }
        },
        {
          id: "el-text-headline",
          type: "text",
          layout: { x: 30, y: -20, w: 756, h: showSubHeading ? 100 : 90, z: 2 },
          content: {
            type: "doc",
            content: buildHeadlineContent(
              brandName ? brandName.toUpperCase() : "WE'RE HIRING",
              "#f59b20",
              "#ffffff",
              "72px"
            )
          }
        },
        {
          id: "el-qr-1",
          type: "qr",
          layout: { x: 128, y: 170, w: 560, h: 560, z: 3 },
          props: {
            showLabel: false,
            showIcon: false,
            finderColor: "#38b549",
            bgColor: "#ffffff",
            color: "#000000",
            iconSizeRatio: 0.28,
            containerStyle: {
              padding: '24px',
              backgroundColor: '#ffffff'
            }
          }
        },
        {
          id: "el-text-qr-center",
          type: "text",
          layout: { x: 348, y: 390, w: 120, h: 120, z: 5 },
          props: {
            containerStyle: {
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }
          },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [
                  { type: "text", text: "SCAN", marks: [{ type: "bold" }, { type: "textStyle", attrs: { color: "#38b549", fontSize: "18px" } }] },
                  { type: "hardBreak" },
                  { type: "text", text: "TO", marks: [{ type: "bold" }, { type: "textStyle", attrs: { color: "#38b549", fontSize: "18px" } }] },
                  { type: "hardBreak" },
                  { type: "text", text: "APPLY", marks: [{ type: "bold" }, { type: "textStyle", attrs: { color: "#38b549", fontSize: "18px" } }] }
                ]
              }
            ]
          }
        },
        {
          id: "el-text-scan-prompt",
          type: "text",
          layout: { x: 30, y: 720, w: 756, h: 60, z: 4 },
          content: {
            type: "doc",
            content: [
              {
                type: "heading",
                attrs: { level: 2, textAlign: "center" },
                content: [
                  { type: "text", text: "SCAN TO APPLY NOW.", marks: [{ type: "textStyle", attrs: { color: "#f59b20", fontSize: "48px" } }] }
                ]
              }
            ]
          }
        },
        {
          id: "el-text-instructions",
          type: "text",
          layout: { x: 30, y: 840, w: 560, h: 60, z: 2 },
          props: {
            containerStyle: {
              backgroundColor: "#f59b20",
              display: "flex",
              padding: "5px 10px 10px",
              alignItems: "center",
              justifyContent: "center"
            }
          },
          content: {
            type: "doc",
            content: [
              {
                type: "heading",
                attrs: { level: 3, textAlign: "center", justifyContent: "center" },
                content: [
                  { type: "text", text: "OR TEXT ", marks: [{ type: "textStyle", attrs: { color: "#000000" } }] },
                  { type: "text", marks: [{ type: "bold" }, { type: "textStyle", attrs: { color: "#000000" } }], text: `'${String(keyword || 'JOBS').toUpperCase()}'` },
                  { type: "text", text: " TO ", marks: [{ type: "textStyle", attrs: { color: "#000000" } }] },
                  { type: "text", text: defaultABT, marks: [{ type: "bold" }, { type: "textStyle", attrs: { color: "#000000" } }] }
                ]
              }
            ]
          }
        },
        {
          id: "el-logo-1",
          type: "logo",
          layout: { x: 610, y: 830, w: 176, h: 80, z: 1 },
          props: { url: logoUrl, fitMode: "contain", alignment: "right" }
        },
        ...(showCareerSite ? [{
          id: "el-text-career-site",
          type: "text",
          layout: { x: 50, y: 920, w: 716, h: 20, z: 8 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [
                  { type: "text", text: "You may also visit ", marks: [{ type: "textStyle", attrs: { color: "#ffffff" } }] },
                  { type: "text", text: trimmedCareerSiteUrl, marks: [{ type: "textStyle", attrs: { color: "#f59b20" } }] }
                ]
              }
            ]
          }
        }] : []),
        ...(showDisclaimer ? [{
          id: "el-text-disclaimer",
          type: "text",
          layout: { x: 50, y: showCareerSite ? 944 : 924, w: 716, h: 20, z: 9 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [{ type: "text", text: trimmedDisclaimer, marks: [{ type: "textStyle", attrs: { color: "#ffffff" } }] }]
              }
            ]
          }
        }] : []),
        {
          id: "el-text-trademark",
          type: "text",
          layout: { x: 50, y: (showCareerSite ? 968 : 948) + (showDisclaimer ? 0 : -20), w: 716, h: 40, z: 11 },
          content: {
            type: "doc",
            content: [
              {
                type: "paragraph",
                attrs: { textAlign: "center" },
                content: [
                  { type: "text", text: "Apply by Text and Scan to Apply are registered trademarks of", marks: [{ type: "textStyle", attrs: { color: "#ffffff", fontSize: "10px" } }] },
                  { type: "hardBreak" },
                  { type: "text", text: "GoHire, Inc. * GoHire.com", marks: [{ type: "textStyle", attrs: { color: "#ffffff", fontSize: "10px" } }] }
                ]
              }
            ]
          }
        }
      ]
    }
  ];
};
